export type FacilityStatus = 'pending' | 'active' | 'suspended' | 'closed' | 'rejected';
export type UtilizationStatus = 'pending' | 'approved' | 'declined';
export type CreditEventType =
  | 'credit_reserved'
  | 'credit_released'
  | 'credit_utilized'
  | 'credit_repaid'
  | 'credit_adjusted'
  | 'limit_changed';

export type BnplStatus = FacilityStatus | UtilizationStatus;

export const facilityStatusLabels: Record<FacilityStatus, string> = {
  pending: 'Pending',
  active: 'Active',
  suspended: 'Suspended',
  closed: 'Closed',
  rejected: 'Rejected',
};

export const utilizationStatusLabels: Record<UtilizationStatus, string> = {
  pending: 'Pending',
  approved: 'Approved',
  declined: 'Declined',
};

export const creditEventTypeLabels: Record<CreditEventType, string> = {
  credit_reserved: 'Credit Reserved',
  credit_released: 'Credit Released',
  credit_utilized: 'Credit Utilized',
  credit_repaid: 'Credit Repaid',
  credit_adjusted: 'Credit Adjusted',
  limit_changed: 'Limit Changed',
};

interface StatusStyle {
  color: string;
  bgColor: string;
}

const statusStyles: Record<string, StatusStyle> = {
  pending: { color: '#C2C2C2', bgColor: 'rgba(194, 194, 194, 0.08)' },
  active: { color: '#51E03E', bgColor: 'rgba(81, 224, 62, 0.08)' },
  approved: { color: '#51E03E', bgColor: 'rgba(81, 224, 62, 0.08)' },
  suspended: { color: '#FF9800', bgColor: 'rgba(255, 152, 0, 0.08)' },
  closed: { color: '#E03E52', bgColor: 'rgba(224, 62, 82, 0.08)' },
  rejected: { color: '#E03E52', bgColor: 'rgba(224, 62, 82, 0.08)' },
  declined: { color: '#E03E52', bgColor: 'rgba(224, 62, 82, 0.08)' },
};

export const getStatusStyle = (status: string): StatusStyle => {
  return statusStyles[status] || { color: '#C2C2C2', bgColor: 'rgba(194, 194, 194, 0.08)' };
};

export const facilityStatusTransitions: Record<FacilityStatus, FacilityStatus[]> = {
  pending: ['active', 'rejected'],
  active: ['suspended', 'closed'],
  suspended: ['active', 'closed'],
  closed: [],
  rejected: [],
};

export const formatAmount = (amount: number | undefined | null): string => {
  if (amount === undefined || amount === null) return '---';
  return `${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} AED`;
};
